import { defineComponent as p, computed as l, createBlock as t, openBlock as a, unref as r, normalizeClass as i, withCtx as v, createElementVNode as h, createCommentVNode as g } from "vue";
import { RevButtonBase as C } from "@ds/components/ButtonBase";
import b from "../../../icons/generated/IconArrowDown.vue2.js";
import E from "../../../icons/generated/IconArrowUp.vue2.js";
import N from "../../../icons/generated/IconSort.vue2.js";
import { tw as e } from "../../../utils/tailwind.js";
const x = /* @__PURE__ */ p({
  __name: "TableSortingHeader",
  props: {
    value: {}
  },
  emits: ["change"],
  setup(c, { emit: u }) {
    const o = c, s = u, d = l(() => [
      e`ring-default-hi-color group rounded-sm size-32 p-4 hover:bg-action-default-min-hover`,
      o.value === "UNDEFINED" ? e`hover:bg-action-default-low-hover` : e`hover:bg-action-default-low-hoverpressed`
    ]), m = l(() => [
      e`rounded-xs flex size-24 items-center justify-center border`,
      o.value === "UNDEFINED" ? e`bg-action-default-low border-action-default-hi text-onaction-default-low group-hover:bg-action-default-low-hover` : e`bg-action-default-low-pressed border-action-default-hi-pressed text-onaction-default-low-pressed group-hover:bg-action-default-low-hoverpressed`
    ]), f = () => {
      o.value === "ASC" ? s("change", "DESC") : o.value === "DESC" ? s("change", "UNDEFINED") : s("change", "ASC");
    };
    return (n, D) => (a(), t(r(C), {
      class: i(d.value),
      onClick: f
    }, {
      default: v(() => [
        h("div", {
          class: i(m.value)
        }, [
          n.value === "ASC" ? (a(), t(r(E), {
            key: 0,
            "data-test": "icon-sort-asc",
            size: "16"
          })) : n.value === "DESC" ? (a(), t(r(b), {
            key: 1,
            "data-test": "icon-sort-desc",
            size: "16"
          })) : n.value === "UNDEFINED" ? (a(), t(r(N), {
            key: 2,
            "data-test": "icon-sort-null",
            size: "16"
          })) : g("", !0)
        ], 2)
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
export {
  x as default
};
